import React, { useState } from 'react';
import * as api from '../../../api/contentStudioV2';
import { useLanguage } from '../../../contexts/LanguageContext';

const Step1Objective = ({ sessionId, token, user, onComplete, setError, setLoading }) => {
  const [selected, setSelected] = useState(null);
  const { t } = useLanguage();

  const objectives = [
    { 
      id: 'Sales', 
      icon: '💰', 
      title: t('cs.steps.objective.sales'),
      desc: 'Drive conversions and purchases', 
      req: 'Requires ≥1 Product or Service' 
    },
    { 
      id: 'Branding', 
      icon: '✨', 
      title: t('cs.steps.objective.branding'),
      desc: 'Build brand awareness', 
      req: 'Can use Values, Products, or Services' 
    },
    { 
      id: 'Awareness', 
      icon: '📢', 
      title: t('cs.steps.objective.awareness'),
      desc: 'Increase reach and visibility', 
      req: 'Can use Values, Products, or Services' 
    }
  ];

  const handleContinue = async () => {
    if (!selected) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const result = await api.setObjective(token, sessionId, user.user_id, selected);
      onComplete({ objective: selected, validationRules: result.validation_rules });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 style={{ fontSize: '24px', color: '#fff', marginBottom: '8px' }}>
        {t('cs.steps.objective.subtitle')}
      </h2>
      <p style={{ fontSize: '14px', color: '#fff', opacity: 0.9, marginBottom: '24px' }}>
        Choose the primary goal for this content
      </p>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {objectives.map(obj => (
          <div
            key={obj.id}
            onClick={() => setSelected(obj.id)}
            style={{
              background: selected === obj.id ? '#fff' : 'rgba(255,255,255,0.95)',
              border: selected === obj.id ? '3px solid #F7941E' : '2px solid transparent',
              borderRadius: '12px',
              padding: '16px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: selected === obj.id ? '0 4px 12px rgba(0,0,0,0.15)' : '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'start', gap: '12px' }}>
              <div style={{ fontSize: '32px' }}>{obj.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: '18px', fontWeight: 600, color: '#333', marginBottom: '4px' }}>{obj.title}</div>
                <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>{obj.desc}</div>
                <div style={{ fontSize: '12px', color: '#0e67a2', background: '#E8F4FF', padding: '4px 8px', borderRadius: '4px', display: 'inline-block' }}>
                  {obj.req}
                </div>
              </div>
              {selected === obj.id && (
                <div style={{ color: '#F7941E', fontSize: '24px' }}>✓</div>
              )}
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={handleContinue}
        disabled={!selected}
        style={{
          width: '100%',
          padding: '16px',
          marginTop: '24px',
          background: selected ? '#F7941E' : '#ccc',
          color: '#fff',
          border: 'none',
          borderRadius: '12px',
          fontSize: '16px',
          fontWeight: 600,
          cursor: selected ? 'pointer' : 'not-allowed',
          transition: 'background 0.2s'
        }}
      >
        {t('cs.steps.objective.continue')}
      </button>
    </div>
  );
};

export default Step1Objective;